jQuery(document).ready(function($) {
    function lazyLoadHoverPic() {
        if ( $(window).width() < 1000 ) {
            return;
        }

        const el = $('.nf-team-grid__members__item');

        el.each(function() {
            $(this).find('.hover img').attr( 'src', $(this).find('.hover img').data('src') );
        });
    }

    lazyLoadHoverPic();
    $(window).on('resize', lazyLoadHoverPic);
});